import React, { useContext } from 'react';
import { Button } from 'anf-core-react';
import ESpotContent from '../../../components/ESpotContent/ESpotContent';
import ViewFullDetailsButton from '../../../components/ViewFullDetailsButton/ViewFullDetailsButton';
import AddToBagButton from '../../../components/AddToBagButton/AddToBagButton';
import AppExclusiveButton from '../../../components/AppExclusiveButton/AppExclusiveButton';
import MemberEarlyAccessDescription from '../../../components/MemberEarlyAccessDescription/MemberEarlyAccessDescription';
import StoreQuickviewContext from '../../../contexts/StoreQuickviewContext';
import ProductPageContext from '../../../contexts/ProductPageContext';
import ContentError from '../../../components/ContentError/ContentError';
import ProductNotificationsButton from '../../../features/ProductNotifications/ProductNotificationsButton/ProductNotificationsButton';
import useActionButtonType from '../../../tools/customHooks/useActionButtonType';

const QuickviewAddToBagSection = ({
  activeButtonLabel,
  collectionData,
  tmntData,
  addToBagError,
  handleSubmitForm,
  isButtonDisabled,
  atbLabelText,
  hasSelectableSoldOutSizeTiles,
}) => {
  const StoreQuickviewState = useContext(StoreQuickviewContext);
  const ProductPageState = useContext(ProductPageContext);
  const isQuickviewEdit = ProductPageState.quickviewType === 'edit';

  const quickViewLogin = () => {
    StoreQuickviewState?.storeQuickview?.(ProductPageState);
    document.dispatchEvent(new CustomEvent('authentication-modal:open', { detail: { isSignIn: true } }));
  };

  const actionButtonType = useActionButtonType(isQuickviewEdit);

  return (
    <div className="add-to-bag-form-wrapper_button-section-mfe quickview-desktop">
      <ESpotContent eSpotData={tmntData?.ProductPromoEMS} />
      { actionButtonType === 'memberEarlyAccess' && <MemberEarlyAccessDescription isQuickView /> }
      <ContentError error={addToBagError} />
      <div className="add-to-bag-from-wrapper_action-wrapper" data-testid="add-to-bag-button">
        <ViewFullDetailsButton
          tmntData={tmntData}
        />
        {actionButtonType === 'memberEarlyAccess' && (
          <Button
            fullWidth
            classList="member-early-access-container_button"
            variant="primary"
            brand={collectionData.activeProduct.brand}
            onClick={quickViewLogin}
          >
            {tmntData.earlyAccessSignIn.value}
          </Button>
        )}
        {actionButtonType === 'appExclusive' && (
          <AppExclusiveButton
            brand={collectionData.activeProduct.brand}
            label={tmntData?.pdpOpenAppToShop?.value}
          />
        )}
        {actionButtonType === 'productNotifications' && (
          <ProductNotificationsButton
            brand={collectionData.activeProduct.brand}
            tmntData={tmntData}
          />
        )}
        {actionButtonType === 'default' && (
          <AddToBagButton
            brand={collectionData.activeProduct.brand}
            label={atbLabelText}
            handleAddToBag={handleSubmitForm}
            activeButtonLabel={activeButtonLabel}
            isButtonDisabled={isButtonDisabled}
            hasSelectableSoldOutSizeTiles={hasSelectableSoldOutSizeTiles}
          />
        )}
      </div>
    </div>
  );
};

export default QuickviewAddToBagSection;
